import React from 'react'
import { TextField } from '@material-ui/core'
import classes from './Form.module.sass'

export function Input({ register, name, ...rest }) {
  return (
    <TextField
      InputLabelProps={{ classes: { shrink: classes.shrink } }}
      {...register(name)}
      {...rest}
    />
  )
}
